export default __webpack_public_path__ + "static/media/TtFooter.af335f4b.png";